import TestAwardFrame from "./components/TestAwardFrame";
import TestAwardForm from "./components/TestAwardForm";
import UserAccountRoutes from "../front_user_account/routes";

export default [
    {
        path: "/test-design-award",
        name: "test-design-award",
        redirect: "/test-design-award/account",
        meta: {
            auth: true,
            basePath: true,
            award: "testaward",
            awardName: "Test Design Award",
        },
        component: TestAwardFrame,
        children: [
            {
                path: "",
                component: TestAwardForm,
                name: "test-design-award-form",
            },
            ...UserAccountRoutes,
        ],
    },
];
